define('adminLisAnaTabs',[
  'module',
  'underscore'
], function(
  module,
  _
) {
  'use strict';

  module.exports = [
    {
      name: 'detail',
      title: _.i18n('lisanas.details.tabTitle')
    }
  ];
});
